import { IUrlInformation } from "api/interfaces/get-page-details/common/nested-pagecontent.type";
import { IMakeModelActualResponse, IMakeModelPageContent } from "api/interfaces/get-page-details/make-model-page.type";
import CategorySection from "component/design-system/category-selection/CategorySection";
import { MAKE_MODEL_YEAR } from "component/vehicle-form/constants";
import { RootState } from "interfaces/generics.type";
import PageContainer from "modules/components/PageContainer";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { openModal } from "../../action/modal/openModal";
import usePrevious from "../../hoc/usePrevious";
import { equalVehicles } from "../../util/vehicle/equal-vehicles";
import DynamicOrderComponents from "./DynamicOrderComponents";
import YearCards from "./year-cards/YearCards";
import MetaHead from "./common/MetaHead";
import PageHeader from "./common/PageHeader";

interface IProps {
  urlInformation: IUrlInformation;
  staticContent: IMakeModelPageContent;
  actualResponse: IMakeModelActualResponse;
}

function MakeModelPage(props: IProps) {
  const {
    actualResponse, urlInformation, staticContent,
  } = props;
  const {
    pageDetails, pageStructure, relatedProducts,
  } = staticContent;
  const {
    tiersMakeModelPagesWithUrl, makeUrl, breadCrumbsV2,
    yearMakeModelsWithUrl,
  } = actualResponse;
  const { displayableMake, displayableModel } = pageDetails;
  const { make, model } = urlInformation;

  const router = useRouter();
  const { pathname } = router.query;

  const selectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);
  const prevSelectedVehicle = usePrevious(selectedVehicle);
  const dispatch = useDispatch();
  const { t } = useTranslation("common");

  useEffect(() => {
    if (displayableMake && displayableModel) {
      dispatch(openModal("vehicleSelector", {
        title: `${t("Select Year for")} ${displayableMake} ${displayableModel}`,
        // years,
        defaultMake: make,
        defaultModel: model,
        selectionOrder: MAKE_MODEL_YEAR,
      }));
    }
  }, []);

  useEffect(() => {
    if (!equalVehicles(prevSelectedVehicle, selectedVehicle)) {
      // user have selected new vehicle
      router.push("/#regular-service");
    }
  }, [selectedVehicle]);

  const vehicle = { make, model };

  const makeModelCategoryUrls = tiersMakeModelPagesWithUrl;
  // .map((_) => ({ ..._, jsLink: !popularMakeModelCategories.includes(_.url) }))
  // .sort((a, b) => a.jsLink - b.jsLink);

  let pageContainer;
  if (pageStructure && pageStructure.length) {
    pageContainer = (

      <DynamicOrderComponents
        {...{ pageStructure }}
        {...{
          make,
          model,
          relatedProducts,
          makeModelCategoryUrls,
          displayableMake,
          displayableModel,
        }}
      />
    );
  }
  return (
    <PageContainer fullWidth>

      <MetaHead
        {...{
          ...staticContent.metaData,
          ...staticContent.pageDetails,
          pathname,
          breadCrumbsList: breadCrumbsV2[0] || [],
        }}
      />

      <PageHeader {...{
        vehicle, pageDetails, makeUrl, staticContent, breadCrumbsV2,
      }}
      />
      {pageContainer}
      <div>
        <CategorySection {...{
          title: t("Browse By Year"),
          categoryUrls: yearMakeModelsWithUrl,
        }}
        >
          <YearCards />
        </CategorySection>

      </div>

    </PageContainer>
  );
}

export default MakeModelPage;
